import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import { COMMON_PAGE_SIZE_OPTIONS } from '../../../../constants';
import CommonDropdown from '../../../../components/common-dropdown/CommonDropdown';
import { changeDemoRecreateTableSettings } from '../../../../redux/user-management/userManagementReducer';
import SearchInput from '../../../../components/common-inputs/SearchInput';

import scss from './DemoUsersFilters.module.scss';

function DemoUsersFilters() {
  const dispatch = useDispatch();
  const { t } = useTranslation('userManagement');

  const size = useSelector((state) => state.userManagement.demoRecreateTableSettings.size);
  const query = useSelector((state) => state.userManagement.demoRecreateTableSettings.query);

  const handleChangeTableSize = (newSize) => {
    dispatch(changeDemoRecreateTableSettings({ size: newSize, page: 0 }));
  };

  const handleSearch = (newSearch) => {
    dispatch(changeDemoRecreateTableSettings({ query: newSearch, page: 0 }));
  };

  return (
    <div className={scss.wrapper}>
      <SearchInput size='sm' value={query} onChange={handleSearch} maxWidth={320} />

      <WithLabel label={t('show')} variant={LABEL_STYLES.ROW} isBold maxWidth={150}>
        <CommonDropdown options={COMMON_PAGE_SIZE_OPTIONS} value={size} onSelect={handleChangeTableSize} />
      </WithLabel>
    </div>
  );
}

export default DemoUsersFilters;
